import { startCase } from 'lodash';
import { DateTime } from 'luxon';
import {
  format,
  formatDistanceToNow,
  isToday,
  isYesterday,
  parseISO,
} from 'date-fns';
import { DatePickerConstans } from '@sparrow-marketing/storybook';
import {
  CHANNELS_BY_GROUP,
  CHANNEL_GROUP,
  ENABLED_CHANNELS,
} from '../../constants';
import { scheduleInterval } from './constants';

const { PERIOD_OPTIONS } = DatePickerConstans;

export const formatReportRange = (fromDate, toDate) => {
  const reportStartDate = DateTime.fromISO(fromDate, { zone: 'utc' });
  const reportEndDate = DateTime.fromISO(toDate, { zone: 'utc' });
  // Calculate the last day of the month
  const lastDayOfMonth = new Date(
    reportEndDate.year,
    reportEndDate.month,
    0
  ).getDate();

  const currentYear = DateTime.local().get('year');

  /* WILL USE AS PER REQUIREMENT */
  // const yesterday = DateTime.local().minus({ day: 1 });

  // if (reportEndDate.hasSame(yesterday, 'day')) {
  //   const diff = reportEndDate.diff(reportStartDate, ['days']);

  //   switch (true) {
  //     case diff.days === 7:
  //       return PERIOD_OPTIONS.lastWeek;
  //     case diff.days === 14:
  //       return PERIOD_OPTIONS.last14Days;
  //     case diff.days === 28:
  //       return PERIOD_OPTIONS.last28Days;
  //     default:
  //       break;
  //   }
  // }

  // const lastMonth = DateTime.local().minus({ month: 1 });

  // if (reportEndDate.hasSame(lastMonth, 'month')) {
  //   return PERIOD_OPTIONS.lastMonth;
  // }

  // const lastQuarter = DateTime.local().minus({ quarter: 1 });

  // if (reportEndDate.hasSame(lastQuarter, 'quarter')) {
  //   return PERIOD_OPTIONS.lastQuarter;
  // }

  if (
    reportStartDate.month === reportEndDate.month &&
    reportStartDate.day === 1 &&
    reportEndDate.day === lastDayOfMonth
  ) {
    // Display on table if a full month was selected as just the month and the year
    return `${reportStartDate.toFormat('MMM dd')} - ${reportEndDate.toFormat(
      'MMM dd, y'
    )}`;
  }

  if (reportEndDate.year > reportStartDate.year) {
    return `${reportStartDate.toFormat('MMM d y', {
      localeMatcher: 'default',
    })} - ${reportEndDate.toFormat('MMM d, y', { localeMatcher: 'default' })}`;
  }

  if (reportEndDate.year < currentYear) {
    return `${reportStartDate.toFormat('MMM d', {
      localeMatcher: 'default',
    })} - ${reportEndDate.toFormat('MMM d, y', { localeMatcher: 'default' })}`;
  }

  return `${reportStartDate.toFormat('MMM d', {
    localeMatcher: 'default',
  })} - ${reportEndDate.toFormat('MMM dd, y', { localeMatcher: 'default' })}`;
};

export const getRefreshInterval = period => {
  switch (period) {
    case PERIOD_OPTIONS.lastWeek:
      return scheduleInterval.WEEKLY;

    case PERIOD_OPTIONS.lastMonth:
      return scheduleInterval.MONTHLY;

    case PERIOD_OPTIONS.lastQuarter:
      return scheduleInterval.QUARTERLY;

    case PERIOD_OPTIONS.last14Days:
    case PERIOD_OPTIONS.last28Days:
    case PERIOD_OPTIONS.custom:
    default:
      return scheduleInterval.DAILY;
  }
};

export const getTemplateChannels = channels => {
  if (channels?.includes('all')) {
    return ENABLED_CHANNELS;
  }
  if (channels?.includes('socials')) {
    return CHANNELS_BY_GROUP[CHANNEL_GROUP.social].filter(channel =>
      ENABLED_CHANNELS.includes(channel)
    );
  }

  const uniqueChannels = [...(channels ?? [])].filter(
    (channel, index) => channels.indexOf(channel) === index
  );
  return uniqueChannels;
};

export const removeSWhenSingular = (category, count) => {
  if (count < 2 && category.slice(-1) === 's') {
    return `${count} ${startCase(category.slice(0, -1))}`;
  }

  return `${count} ${startCase(category)}`;
};

export const getHumanReadableDate = timestamp => {
  const date =
    typeof timestamp === 'string' ? parseISO(timestamp) : new Date(timestamp);

  if (isToday(date)) {
    return 'Today';
  }
  if (isYesterday(date)) {
    return 'Yesterday';
  }
  return format(date, 'MMM d, yyyy');
};
